import * as tslib_1 from "tslib";
import { SEARCH_BOX_SOURCE } from '../utils/searchViewConstants';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { TooltipHost, TooltipOverflowMode } from 'office-ui-fabric-react/lib/Tooltip';
import { CategoryIcon } from 'owa-categories';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { getIconForFile } from 'owa-file-icon';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { searchStore } from 'owa-mail-search-store';
import getCanAddMoreSuggestionPills from 'owa-mail-search-store/lib/helpers/getCanAddMoreSuggestionPills';
import getSuggestionsSet from 'owa-mail-search-store/lib/helpers/getSuggestionsSet';
import { SuggestionSegment } from 'owa-mail-search-view/lib/components/segments/SuggestionSegment';
import { getFormattedDate } from 'owa-mail-store-actions';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import { lazyLogEntityClicked, lazyLogResponseRendered } from 'owa-search-service';
import { trace } from 'owa-trace';
import * as React from 'react';
import highlightDisplayText, { dehighlightDisplayText, } from '../utils/highlightDisplayText';
import { SuggestionKind, } from 'owa-search-service';
import { ContextualMenu, } from 'office-ui-fabric-react/lib/components/ContextualMenu';
import { personaCardBehavior, } from 'owa-persona/lib/components/PersonaCardBehavior';
var styles = require('./SuggestionsContextMenu.scss');
var classNames = require('classnames/bind');
var personaCard = function (props) {
    return React.createElement(Icon, { className: styles.personaIcon, iconName: "ContactCard" /* ContactCard */ });
};
var PersonaContactCard = personaCardBehavior(personaCard);
var SuggestionsContextMenu = /** @class */ (function (_super) {
    tslib_1.__extends(SuggestionsContextMenu, _super);
    function SuggestionsContextMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.suggestions = [];
        _this.createKeywordSuggestionItem = function (traceId, suggestion, index) {
            var highlightTextRegions = highlightDisplayText(suggestion.DisplayText);
            return {
                key: suggestion.DisplayText,
                name: suggestion.DisplayText,
                className: searchStore.selectedSuggestionIndex == index && styles.suggestionSelected,
                onRender: function () { return (React.createElement("div", { tabIndex: 0, key: suggestion.DisplayText, className: styles.keywordSuggestion, "data-click-source": SEARCH_BOX_SOURCE, 
                    // VSO:17221 as a part of 17221, we should change onMouseDown to onClick
                    onMouseDown: function () {
                        _this.props.onListTypeSuggestionClicked(suggestion);
                        _this.logSuggestionEntityClicked(traceId, suggestion.ReferenceId);
                    }, title: dehighlightDisplayText(suggestion.DisplayText) },
                    React.createElement(Icon, { className: styles.suggestionIcon, iconName: suggestion.Attributes && suggestion.Attributes.IsHistory
                            ? "History" /* History */
                            : "Search" /* Search */ }),
                    highlightTextRegions.filter(function (e) { return e.text.length > 0; }).map(function (e) {
                        var className = e.isHighlighted
                            ? styles.keywordMatchSuggestion
                            : styles.keywordNonMatchSuggestion;
                        return React.createElement("div", { className: className }, e.text);
                    }))); },
            };
        };
        _this.createSegmentedSuggestionItem = function (traceId, suggestion, index) {
            suggestion.Segments;
            return {
                key: suggestion.ReferenceId,
                name: suggestion.ReferenceId,
                className: searchStore.selectedSuggestionIndex == index && styles.suggestionSelected,
                onRender: function () { return (React.createElement("div", { tabIndex: 0, key: suggestion.ReferenceId, className: styles.segmentedSuggestion, "data-click-source": SEARCH_BOX_SOURCE, 
                    // VSO:17221 as a part of 17221, we should change onMouseDown to onClick
                    onMouseDown: function () {
                        _this.props.onListTypeSuggestionClicked(suggestion);
                        _this.logSuggestionEntityClicked(traceId, suggestion.ReferenceId);
                    }, title: dehighlightDisplayText(suggestion.DisplayText) }, suggestion.Segments.map(function (segment) { return React.createElement(SuggestionSegment, { segment: segment }); }))); },
            };
        };
        _this.createPeopleSuggestionItem = function (traceId, suggestion, index) {
            return {
                key: suggestion.EmailAddresses[0],
                name: suggestion.DisplayName,
                className: searchStore.selectedSuggestionIndex == index && styles.suggestionSelected,
                onRender: function () { return (React.createElement("div", { tabIndex: 0, key: suggestion.EmailAddresses[0], className: styles.personaSuggestion, "data-click-source": SEARCH_BOX_SOURCE, 
                    // VSO:17221 as a part of 17221, we should change onMouseDown to onClick
                    onMouseDown: function () {
                        _this.props.onListTypeSuggestionClicked(suggestion);
                        // Logging is only done for suggestions that are received
                        // from substrate backend, only during which traceId has a value.
                        // So for people suggestions that are received from FindPeople
                        // we shall not receive traceId and logging shall not happen
                        _this.logSuggestionEntityClicked(traceId, suggestion.ReferenceId);
                    } },
                    React.createElement("div", { className: styles.personaControl },
                        React.createElement(PersonaControl, { name: suggestion.DisplayName, emailAddress: suggestion.EmailAddresses[0], size: PersonaSize.size28, showPresence: false, showPersonaDetails: true, onRenderPrimaryText: function (props) { return (React.createElement(TooltipHost, { content: props.primaryText, overflowMode: TooltipOverflowMode.Parent, directionalHint: 0 /* topLeftEdge */ }, highlightDisplayText(suggestion.HighlightedDisplayName)
                                .filter(function (e) { return e.text.length > 0; })
                                .map(function (e) { return (React.createElement("div", { className: e.isHighlighted
                                    ? styles.keywordMatchSuggestion
                                    : styles.keywordNonMatchSuggestion }, e.text)); }))); } })),
                    isControlFeatureEnabled('sea-personaCardInSuggestions') && (React.createElement(PersonaContactCard, { name: suggestion.DisplayName, emailAddress: suggestion.EmailAddresses[0], personaType: 'User' })))); },
            };
        };
        _this.createMessageSuggestionItem = function (traceId, suggestion, index) {
            var highlightSubjectRegions = highlightDisplayText(suggestion.Subject);
            var highlightDisplayNameRegions = highlightDisplayText(suggestion.DisplayName);
            return {
                key: suggestion.Subject,
                name: suggestion.Subject,
                className: searchStore.selectedSuggestionIndex == index && styles.suggestionSelected,
                onRender: function () { return (React.createElement("div", { tabIndex: 0, key: suggestion.Subject, className: styles.messageSuggestion, "data-click-source": SEARCH_BOX_SOURCE, 
                    // VSO:17221 as a part of 17221, we should change onMouseDown to onClick
                    onMouseDown: function () {
                        _this.props.onListTypeSuggestionClicked(suggestion);
                        _this.logSuggestionEntityClicked(traceId, suggestion.ReferenceId);
                    }, title: suggestion.Subject },
                    React.createElement("div", { className: styles.messageSuggestionFirstLine },
                        React.createElement(Icon, { className: styles.suggestionIcon, iconName: "Mail" /* Mail */ }),
                        React.createElement("span", { className: styles.messageSuggestionSubject }, highlightSubjectRegions
                            .filter(function (e) { return e.text.length > 0; })
                            .map(_this.createHighlightRegion)),
                        React.createElement("span", { className: styles.messageSuggestionDateTime }, suggestion.DateTimeReceived &&
                            getFormattedDate(suggestion.DateTimeReceived))),
                    React.createElement("div", { className: styles.messageSuggestionName }, highlightDisplayNameRegions
                        .filter(function (e) { return e.text.length > 0; })
                        .map(_this.createHighlightRegion)))); },
            };
        };
        _this.createFileSuggestionItem = function (traceId, suggestion, index) {
            var fileIcon = getIconForFile(suggestion.Name);
            return {
                key: suggestion.ReferenceId,
                name: suggestion.Name,
                className: searchStore.selectedSuggestionIndex == index && styles.suggestionSelected,
                onRender: function () { return (React.createElement("div", { tabIndex: 0, key: suggestion.ReferenceId, className: styles.fileSuggestion, "data-click-source": SEARCH_BOX_SOURCE, 
                    // VSO:17221 as a part of 17221, we should change onMouseDown to onClick
                    onMouseDown: function () {
                        _this.props.onFileSuggestionClick(suggestion);
                        _this.logSuggestionEntityClicked(traceId, suggestion.ReferenceId);
                    } },
                    React.createElement("div", { className: styles.fileIconContainer, "data-is-focusable": false },
                        React.createElement("i", { className: classNames(fileIcon.small, styles.fileIcon) })),
                    React.createElement("div", { className: styles.fileInfoContainer, "data-is-focusable": false }, highlightDisplayText(suggestion.HighlightedDisplayText)
                        .filter(function (e) { return e.text.length > 0; })
                        .map(function (e) {
                        var className = e.isHighlighted
                            ? styles.keywordMatchSuggestion
                            : styles.keywordNonMatchSuggestion;
                        return React.createElement("div", { className: className }, e.text);
                    })))); },
            };
        };
        _this.createCategorySuggestionItem = function (suggestion, index) {
            var categoryName = suggestion.Name;
            var searchText = searchStore.searchTextForSuggestion;
            var matchText = '';
            var nonMatchText = categoryName;
            if (categoryName.toLocaleLowerCase().indexOf(searchText.toLocaleLowerCase()) == 0) {
                matchText = categoryName.substr(0, searchText.length);
                nonMatchText = categoryName.substr(searchText.length, categoryName.length - 1);
            }
            return {
                key: suggestion.ReferenceId,
                name: categoryName,
                className: searchStore.selectedSuggestionIndex == index && styles.suggestionSelected,
                onRender: function () { return (React.createElement("div", { tabIndex: 0, key: suggestion.ReferenceId, className: styles.keywordSuggestion, "data-click-source": SEARCH_BOX_SOURCE, 
                    // VSO:17221 as a part of 17221, we should change onMouseDown to onClick
                    onMouseDown: function () {
                        _this.props.onListTypeSuggestionClicked(suggestion);
                    } },
                    React.createElement(CategoryIcon, { categoryName: categoryName, iconClassName: styles.suggestionCategoryIcon }),
                    React.createElement("span", { className: styles.keywordMatchSuggestion }, matchText),
                    React.createElement("span", { className: styles.keywordNonMatchSuggestion }, nonMatchText))); },
            };
        };
        _this.createHighlightRegion = function (textRegion) {
            var className = textRegion.isHighlighted
                ? styles.keywordMatchSuggestion
                : styles.keywordNonMatchSuggestion;
            return React.createElement("span", { className: className }, textRegion.text);
        };
        _this.logSuggestionEntityClicked = function (traceId, referenceId) {
            if (isMailFeatureEnabled('sea-qf') && traceId) {
                lazyLogEntityClicked.importAndExecute(traceId, referenceId, new Date());
            }
        };
        return _this;
    }
    SuggestionsContextMenu.prototype.render = function () {
        return (React.createElement(ContextualMenu, { useTargetWidth: true, shouldFocusOnMount: false, target: this.props.targetElement, gapSpace: 2, directionalHintFixed: true, directionalHint: 4 /* bottomLeftEdge */, items: this.suggestionMenuItems }));
    };
    Object.defineProperty(SuggestionsContextMenu.prototype, "suggestionMenuItems", {
        get: function () {
            var _this = this;
            var items = this.suggestions;
            var suggestionSet = getSuggestionsSet();
            if (suggestionSet && suggestionSet.IsComplete) {
                items = [];
                var shouldShowPillSuggestions_1 = getCanAddMoreSuggestionPills();
                var isMessageSuggestionDividerAdded = false;
                suggestionSet.Suggestions.map(function (suggestion, index) {
                    switch (suggestion.kind) {
                        case SuggestionKind.People:
                            if (shouldShowPillSuggestions_1) {
                                items.push(_this.createPeopleSuggestionItem(suggestionSet.TraceId, suggestion, index));
                            }
                            break;
                        case SuggestionKind.Keywords:
                            items.push(suggestion.Segments
                                ? _this.createSegmentedSuggestionItem(suggestionSet.TraceId, suggestion, index)
                                : _this.createKeywordSuggestionItem(suggestionSet.TraceId, suggestion, index));
                            break;
                        case SuggestionKind.Message:
                            if (!isMessageSuggestionDividerAdded) {
                                items.push({
                                    key: 'search_messageSuggestion_divider',
                                    name: '-',
                                });
                                isMessageSuggestionDividerAdded = true;
                            }
                            items.push(_this.createMessageSuggestionItem(suggestionSet.TraceId, suggestion, index));
                            break;
                        case SuggestionKind.Category:
                            if (shouldShowPillSuggestions_1) {
                                items.push(_this.createCategorySuggestionItem(suggestion, index));
                            }
                            break;
                        case SuggestionKind.Files:
                            items.push(_this.createFileSuggestionItem(suggestionSet.TraceId, suggestion, index));
                            break;
                        default:
                            trace.error('suggestionMenuItems: Suggestion type not supported');
                    }
                });
                if (isMailFeatureEnabled('sea-qf')) {
                    lazyLogResponseRendered.importAndExecute(suggestionSet.TraceId, new Date());
                }
            }
            return (this.suggestions = items);
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        computed
    ], SuggestionsContextMenu.prototype, "suggestionMenuItems", null);
    SuggestionsContextMenu = tslib_1.__decorate([
        observer
    ], SuggestionsContextMenu);
    return SuggestionsContextMenu;
}(React.Component));
export default SuggestionsContextMenu;
//# sourceMappingURL=SuggestionsContextMenu.js.map